<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 32,
      height: 32,
      color: 'currentColor',
      viewBoxValue: `0 0 33 32`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <g id="at-sign">
      <path
        id="Icon"
        d="M22.1359 10.6667V17.3333C22.1359 18.3942 22.5573 19.4116 23.3075 20.1618C24.0576 20.9119 25.0751 21.3333 26.1359 21.3333C27.1968 21.3333 28.2142 20.9119 28.9643 20.1618C29.7145 19.4116 30.1359 18.3942 30.1359 17.3333V16C30.1357 12.9907 29.1176 10.07 27.2469 7.71271C25.3763 5.35545 22.7633 3.7003 19.8328 3.0164C16.9022 2.33249 13.8265 2.66006 11.1057 3.94582C8.38493 5.23159 6.17911 7.39994 4.84693 10.0983C3.51474 12.7967 3.13454 15.8663 3.76814 18.8082C4.40174 21.75 6.01189 24.391 8.33676 26.3017C10.6616 28.2124 13.5645 29.2805 16.5733 29.3322C19.5822 29.3839 22.5201 28.4163 24.9093 26.5867M22.1359 16C22.1359 18.9455 19.7481 21.3333 16.8026 21.3333C13.8571 21.3333 11.4693 18.9455 11.4693 16C11.4693 13.0545 13.8571 10.6667 16.8026 10.6667C19.7481 10.6667 22.1359 13.0545 22.1359 16Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </IconBase>
</template>

<style scoped lang="scss"></style>
